module.exports = __webpack_public_path__ + "img/dizzy_face.fa36e084.gif";